import type { SpanSchema } from "../types/project"

// Define span property constants for consistent access
// These are the display names that will be shown in the UI
export const SPAN_PROPERTIES = [
    "Span Number",
    "Span No",
    "Start Tower",
    "End Tower",
    "Start Location",
    "End Location",
    "Section Name",
    "Span Length",
    "Span",
    "Maximum Sag",
    "Max Sag",
    "Wind Span",
    "Weight Span",
    "Conductor Type",
    "Ground Wire Type",
    "Elevation Change",
    "Terrain Type",
    "Power Line Crossing",
    "River Crossing",
    "Railway Crossing",
    "Highway Crossing",
    "Valley Crossing",
    "Forest Crossing",
    "Length Of Conductor Between Towers",
    "Length Of Jumper Conductors At Towers",
    "Length Of Earthwire 1",
    "Length Of Earthwire 2",
    "Total MS Steel Members",
    "Total HT Steel Members",
    "Total MS Steel Plates",
    "Total HT Steel Plates",
    "Total 16 Dia BN",
    "Total 20 Dia BN",
    "Number Of Soil Types",
    "Total PCC",
    "Total RCC",
    "Total Excavation",
    "Total Reinforcement MS Steel",
    "Total Reinforcement Steel",
    "Conductor Mid Span Compression Joint",
    "Conductor T Connector",
    "Conductor Repair Sleeve",
    "Conductor Quad Spacer Damper",
    "Conductor Insulation Sleeve",
    "Number Of Bird Diverters",
    "Earthwire Mid Span Compression Joint",
    "Is Power Line Crossing",
    "Is River Crossing",
    "Is Railway Line Crossing",
    "Is Highway Crossing",
    "Is Valley Crossing",
    "Is Forest Crossing",
]

// Define span property groups for UI organization
export const SPAN_PROPERTY_GROUPS = {
    "Basic Information": [
        "Span Number",
        "Span No",
        "Start Tower",
        "End Tower",
        "Start Location",
        "End Location",
        "Section Name",
    ],
    "Technical Parameters": [
        "Span Length",
        "Span",
        "Maximum Sag",
        "Max Sag",
        "Wind Span",
        "Weight Span",
        "Conductor Type",
        "Ground Wire Type",
        "Elevation Change",
    ],
    "Conductor & Earthwire": [
        "Length Of Conductor Between Towers",
        "Length Of Jumper Conductors At Towers",
        "Length Of Earthwire 1",
        "Length Of Earthwire 2",
        "Conductor Mid Span Compression Joint",
        "Conductor T Connector",
        "Conductor Repair Sleeve",
        "Conductor Quad Spacer Damper",
        "Conductor Insulation Sleeve",
        "Number Of Bird Diverters",
        "Earthwire Mid Span Compression Joint",
    ],
    "Material Information": [
        "Total MS Steel Members",
        "Total HT Steel Members",
        "Total MS Steel Plates",
        "Total HT Steel Plates",
        "Total 16 Dia BN",
        "Total 20 Dia BN",
        "Number Of Soil Types",
        "Total PCC",
        "Total RCC",
        "Total Excavation",
        "Total Reinforcement MS Steel",
        "Total Reinforcement Steel",
    ],
    "Crossings & Terrain": [
        "Terrain Type",
        "Power Line Crossing",
        "River Crossing",
        "Railway Crossing",
        "Highway Crossing",
        "Valley Crossing",
        "Forest Crossing",
        "Is Power Line Crossing",
        "Is River Crossing",
        "Is Railway Line Crossing",
        "Is Highway Crossing",
        "Is Valley Crossing",
        "Is Forest Crossing",
    ],
}

/**
 * Gets all span properties including dynamic ones from the schema
 * @param schema The span schema containing property definitions
 * @returns Array of property display names
 */
export const getAllSpanProperties = (schema?: SpanSchema) => {
    if (!schema) return SPAN_PROPERTIES

    // Add dynamic properties from schema
    const dynamicProperties = Object.entries(schema)
        .filter(([_, prop]) => (prop as any).isDynamic === true)
        .map(([_, prop]) => prop.title)

    return [...Object.values(SPAN_PROPERTIES), ...dynamicProperties]
    // return [...SPAN_PROPERTIES, ...dynamicProperties]
}

